<template>
    <span>
        <template v-if="actividad.tipo_actividad === 'abierto'">
            Ha abierto el boletín
            <router-link :to="rutaBoletin" class="link">{{ boletin.asunto ? boletin.asunto : actividad.comunicado.asunto }}</router-link>
        </template>
        <template v-else-if="actividad.tipo_actividad === 'clickado'">
            Ha hecho clic en el boletín
            <router-link :to="rutaBoletin" class="link">{{ boletin.asunto ? boletin.asunto : actividad.comunicado.asunto }}</router-link>
        </template>
        <template v-else-if="actividad.tipo_actividad === 'fallido'">
            El envío del boletín
            <router-link :to="rutaBoletin" class="link">{{ boletin.asunto ? boletin.asunto : actividad.comunicado.asunto }}</router-link> ha fallado.
        </template>
        <template v-else-if="actividad.tipo_actividad === 'marcado como spam'">
            El boletín
            <router-link :to="rutaBoletin" class="link">{{ boletin.asunto ? boletin.asunto : actividad.comunicado.asunto }}</router-link> se ha marcado como spam
        </template>
        <template v-else-if="actividad.tipo_actividad === 'enviado'">
            El boletín
            <router-link :to="rutaBoletin" class="link">{{ boletin.asunto ? boletin.asunto : actividad.comunicado.asunto }}</router-link> se ha enviado.
        </template>
        <template v-else>
            Actividad desconocida.
        </template>
    </span>
</template>

<script>
    export default {
        props: {
            actividad: {
                type: Object,
                required: true
            },
            boletin: {
                type: Object,
                default: () => ({})
            }
        },
        computed: {
            rutaBoletin() {
                return `/admin/emails/boletines/${this.boletin.id || this.actividad.comunicado.id}`;
            }
        }
    }
</script>
<style scoped>
.list-group-item {
    cursor: default;
    border-bottom: 0;
    padding: 3px;
}
.link {
    color: #3277b3 !important;
}
.link:hover {
    border-bottom: 1px solid #285f90 !important;
    color: #285f90 !important;
}
</style>